import { render, staticRenderFns } from "./showSponsorsEdition.vue?vue&type=template&id=36b40e52"
import script from "./showSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./showSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports